import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus.js';
import { WifiOff } from 'lucide-react';

export const OfflineIndicator: React.FC = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed bottom-6 left-6 z-50 flex items-center gap-2.5 rounded-2xl bg-amber-600 border border-amber-500 px-4 py-2.5 text-xs font-bold text-white shadow-xl animate-bounce">
      <div className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
      </div>
      <WifiOff className="w-4 h-4 text-amber-100" />
      <span>Mode Luring — Anda sedang luring (offline). Menampilkan data lokal (cache) resmi UIBN.</span>
    </div>
  );
};
